/* Live progress for the "Get your parts in 3 steps" rail.

   Stage 0: nothing known yet.
   Stage 1: a trailer is known (VIN matched, or a model chosen).
   Stage 2: something is in the cart.

   There is no stage 3. We cannot see a completed checkout from the storefront,
   so "Order and ship" stays the current step rather than falsely completing.

   TWO KEYS, NOT ONE. The extension writes lastSearchedTrailer from exactly one
   place, the VIN match path, so a customer who picks Range / Model / Year in
   the chip selector never touches it. The theme's pickbar writes fxTrailerPick
   for that path and fires fx:trailer-changed. Either key counts as knowing the
   trailer, and the header My trailer button reads the same pair, so the rail
   and the button can never disagree.

   STEP ONE IS A CONTROL. It is the only step the customer can act on from
   here, so it scrolls back to the VIN field and puts the caret in it. Steps
   two and three describe what happens next and stay inert.

   Reads only: localStorage for the trailer, the cart bubble for the count.
   No network calls, no writes. */
(function () {
  var RAIL = '.vin-hero-info .vin-hero-steps';
  var WIDTHS = ['16%', '50%', '83%'];
  var armed = null;

  var still = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hasKey(key, fields) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return false;
      var t = JSON.parse(raw);
      if (!t) return false;
      for (var i = 0; i < fields.length; i++) {
        if (t[fields[i]]) return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  function trailerKnown() {
    return hasKey('lastSearchedTrailer', ['vinNumber', 'modelName']) ||
      hasKey('fxTrailerPick', ['modelName', 'rangeName']);
  }

  function cartCount() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return 0;
    var span = bubble.querySelector('span:not([class])') || bubble.querySelector('span');
    var n = span ? parseInt(String(span.textContent).replace(/\D/g, ''), 10) : NaN;
    return isNaN(n) ? 1 : n;
  }

  function stage() {
    if (cartCount() > 0) return 2;
    if (trailerKnown()) return 1;
    return 0;
  }

  function paint() {
    var rail = document.querySelector(RAIL);
    if (!rail) return;
    var s = stage();
    var items = rail.querySelectorAll('.vin-hero-step');
    for (var i = 0; i < items.length; i++) {
      items[i].setAttribute(
        'data-fx-step',
        i < s ? 'done' : i === s ? 'now' : 'todo'
      );
    }
    rail.style.setProperty('--fx-steps-p', WIDTHS[Math.min(s, WIDTHS.length - 1)]);
  }

  /* The VIN field is the extension's, so it is found rather than owned.

     The focus is deliberately late, and then checked. Calling focus() during a
     smooth scroll makes the browser jump straight to the field and the scroll
     is wasted, so it waits for the scroll to land. But a smooth scroll is a
     request, not a promise: it does not run in a background tab and a browser
     is free to ignore it, and focusing a field that is still off screen is a
     worse outcome than no animation at all. So the position is measured when
     the timer fires and, if the field did not arrive, preventScroll is dropped
     and the browser is told plainly to go there. */
  function jump() {
    var input = document.getElementById('vinHeroInput');
    var target = input
      ? (input.closest('.vin-hero-vin-form') || input)
      : document.querySelector('.vin-hero-vin-form, .vin-search-hero');
    if (!target) return;

    target.scrollIntoView({
      behavior: still ? 'auto' : 'smooth',
      block: 'center'
    });

    if (!input) return;
    window.setTimeout(function () {
      var r = target.getBoundingClientRect();
      var landed = r.top >= 0 && r.bottom <= window.innerHeight;
      try { input.focus({ preventScroll: landed }); } catch (e) { input.focus(); }
      if (!landed) target.scrollIntoView({ block: 'center' });
    }, still ? 0 : 520);
  }

  /* The step's own textContent starts with the disc's "1", which a screen
     reader would then announce as "one search by VIN". The disc is decoration,
     so the label is built from everything except it. */
  function labelOf(step) {
    var num = step.querySelector('.vin-hero-step-num');
    var text = '';
    [].forEach.call(step.childNodes, function (n) {
      if (n !== num) text += n.textContent || '';
    });
    return text.replace(/\s+/g, ' ').trim() || 'Search';
  }

  function arm(rail) {
    var first = rail && rail.querySelector('.vin-hero-step');
    if (!first || first.hasAttribute('data-fx-jump')) return;

    first.setAttribute('data-fx-jump', '');
    first.setAttribute('role', 'button');
    first.setAttribute('tabindex', '0');
    first.setAttribute('aria-label', labelOf(first) + '. Go to the VIN search.');

    first.addEventListener('click', jump);
    first.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      jump();
    });
  }

  function boot() {
    var rail = document.querySelector(RAIL);
    if (!rail) return;
    armed = rail;
    paint();
    arm(rail);

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && window.MutationObserver) {
      new window.MutationObserver(paint).observe(bubble, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    /* The extension rebuilds the hero on a brand switch, which takes the step
       list with it. This watches for a DIFFERENT rail node rather than for any
       mutation at all: the parts grid alone fires this callback hundreds of
       times, and repainting on every one of them is waste. Attribute changes
       are not observed, so paint() writing data-fx-step cannot re-enter. */
    if (window.MutationObserver) {
      new window.MutationObserver(function () {
        var live = document.querySelector(RAIL);
        if (!live || live === armed) return;
        armed = live;
        arm(live);
        paint();
      }).observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('storage', paint);
    window.addEventListener('pageshow', paint);
    document.addEventListener('vin:matched', paint);
    document.addEventListener('fx:trailer-changed', paint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
